import {
  ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD,
  ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD_V2,
  ROUTE_SIGN_IN,
} from '@/constants/routes';
import useAnalyticsCalls from '@/hooks/use-analytics';
import { useCheckInviteCode } from '@/queries/invite-code.queries';
import useGetMe from '@/queries/me.queries';
import authService from '@/services/auth.service';
import envService from '@/services/env.service';
import { getRoute } from '@/utils';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

export enum EarlyAccessType {
  vip = 'vip',
  early = 'early',
}

export default function useEarlyAccessController() {
  const navigate = useNavigate();
  const { data: meData } = useGetMe();
  const { inviteCode } = useParams<{ inviteCode: string }>();
  const checkInviteCode = useCheckInviteCode();
  const analytics = useAnalyticsCalls();
  const isRouteGetStartedToPpra = envService.getEnv().VITE_SWITCH_ROUTE_GET_STARTED_TO_PPRA === 'true';

  const userEmail = meData?.account.credential ?? '';

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { inviteCode: inviteCode ?? '' },
  });

  function handleLogout() {
    analytics.callLogoutCompleted();
    authService.logout();
    navigate(getRoute(ROUTE_SIGN_IN));
  }

  const handleSubmit = form.handleSubmit((values) => {
    checkInviteCode
      .mutateAsync(values.inviteCode)
      .then((isValidCode) => {
        if (isValidCode)
          return navigate(
            getRoute(
              isRouteGetStartedToPpra ? ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD_V2 : ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD
            )
          );

        form.setError('inviteCode', { type: 'validate', message: 'Invalid code' });
      })
      .catch((error) => {
        console.error(error);
        form.setError('inviteCode', { type: 'validate', message: 'Invalid code' });
      });
  });

  return { handleLogout, userEmail, form, handleSubmit };
}
